module.exports = __webpack_public_path__ + "static/3_3_spam-or-ham_NL-d1d0ed0765fa81d6ce9150311b488e00.svg";